import React from 'react';
import './App.css';
import { VetRouter } from "./Router";
import { SnackbarProvider } from './contexts/SnackbarContext';
import { UserContextProvider } from './contexts/UserContext';

function App() {
    return (
        <SnackbarProvider>
            <UserContextProvider>
                <VetRouter />
            </UserContextProvider>
        </SnackbarProvider>
    );
}

export default App;
